import { useAuth } from "@/auth";
import { isAdmin } from "@/services/auth.service";
import { useMemo } from "react";
import { Heading } from "react-aria-components";
import { NewCampaignButton } from "../campaign/NewCampaignButton";
import { VideoTutorialThumbnail } from "../campaign/VideoTutorialThumbnail";
import { MainWindow, PageContent } from "./MainWindow";
import { PageHeader } from "./PageHeader";

export function IntroView({ title = "Intro" }: { title?: string }) {
  const { user } = useAuth();

  const isUserAdmin = useMemo(() => isAdmin(user), [user]);

  return (
    <MainWindow>
      <div className="grid size-full grid-cols-2">
        <div className="flex h-full flex-col">
          <PageHeader title={title} />

          <PageContent className="flex grow flex-col justify-center p-14 pt-7">
            <div className="flex max-w-[400px] flex-col gap-y-4">
              <div className="flex flex-col gap-y-4">
                <Heading>
                  {isUserAdmin
                    ? "Start din første kampagne"
                    : "Bed din salgsleder om at oprette en kampagne"}
                </Heading>

                <p className="text-theme-on-background-variant mb-4 text-[12px] leading-loose">
                  Du sidder nu med nøglen til smartere leadgenerering. Lasso
                  Sales hjælper dig med at finde de rigtige virksomheder, de
                  rette beslutningstagere og det perfekte tidspunkt at tage
                  kontakt. Se videoen for en hurtig introduktion -{" "}
                  {isUserAdmin
                    ? "og opret derefter din første kampagne for at komme i gang."
                    : "og bed din salgsleder om at oprette en kampagne til dig, for at komme i gang."}
                </p>
              </div>

              {isUserAdmin && <NewCampaignButton />}
            </div>
          </PageContent>
        </div>

        <VideoTutorialThumbnail />
      </div>
    </MainWindow>
  );
}
